import React, { useState } from 'react';
import { deleteAccount } from '../../api';

const APP_KEYS = ['theme', 'dash_sec', 'questsOpen'];

export default function DeleteAccountCard({ onExport }) {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState('');
  const [typed, setTyped] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr('');
    setBusy(true);
    const res = await deleteAccount(pw, typed.trim());
    setBusy(false);
    if (!res.ok) {
      setErr(res.error || 'Could not delete your account');
      return;
    }
    APP_KEYS.forEach((k) => {
      try { localStorage.removeItem(k); } catch {}
    });
    window.location.replace('/');
  };

  return (
    <div className="card cp danger-zone">
      <div className="st">🗑️ Delete my account</div>
      <p style={{ fontSize: 12, color: 'var(--mut)', marginBottom: 12 }}>
        This permanently erases your budget, spending history, goals, posts and messages. It
        can't be undone. Download a backup first if you might want your data later.
      </p>
      {!open ? (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {onExport && (
            <button className="btn btn-ghost" onClick={onExport}>⬇ Download backup first</button>
          )}
          <button className="btn btn-danger" onClick={() => setOpen(true)}>Delete my account…</button>
        </div>
      ) : (
        <>
          <div className="lf">
            <label>Your password</label>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="current-password" />
          </div>
          <div className="lf">
            <label>Type DELETE to confirm</label>
            <input value={typed} onChange={(e) => setTyped(e.target.value)} autoCapitalize="characters" />
          </div>
          {err && <div className="lerr">{err}</div>}
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button className="btn btn-ghost" onClick={() => { setOpen(false); setPw(''); setTyped(''); setErr(''); }}>
              Cancel
            </button>
            <button
              className="btn btn-danger"
              disabled={busy || !pw || typed.trim() !== 'DELETE'}
              onClick={submit}
            >
              {busy ? 'Deleting…' : 'Permanently delete'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
